import React, { useEffect, useRef, useState } from "react";
import { CircularProgress } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";
import { motion } from "framer-motion";
import axiosInterceptorInstance from "../../../../utils/axios.interceptor";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-community/styles/ag-grid.css";

const RevenueReport = () => {
  const [rowData, setRowData] = useState(null);
  const agGridRef = useRef<AgGridReact | null>(null);

  const controller = new AbortController();

  useEffect(() => {
    return () => {
      controller.abort();
    };
  }, []);

  useEffect(() => {
    fetchDataFromAPI();
  }, []);

  const fetchDataFromAPI = async () => {
    await axiosInterceptorInstance
      .get(`/dashboard/ThmRevenueReport`, { signal: controller.signal })
      .then((response: any) => {
        const responseData = JSON.parse(response.data.body);
        setRowData(responseData.Data);
      })
      .catch((error: any) => {
        console.error(error);
      });
  };

  const exportGridDataAsCSV = () => {
    if (agGridRef.current) {
      agGridRef.current.api.exportDataAsCsv();
    }
  };

  const columnDefs: ColDef[] = [
    {
      field: "Title",
      headerName: "Title",
      filter: true,
      sortable: true,
      pinned: "left",
    },
    {
      field: "Report_Year",
      headerName: "Year",
      filter: true,
      sortable: true,
      pinned: "left",
    },
    {
      field: "Jan",
      headerName: "Jan",
      filter: true,
      sortable: true,
    },
    {
      field: "Feb",
      headerName: "Feb",
      filter: true,
      sortable: true,
    },
    {
      field: "Mar",
      headerName: "Mar",
      filter: true,
      sortable: true,
    },
    {
      field: "apr",
      headerName: "Apr",
      filter: true,
      sortable: true,
    },
    {
      field: "may",
      headerName: "May",
      filter: true,
      sortable: true,
    },
    {
      field: "jun",
      headerName: "Jun",
      filter: true,
      sortable: true,
    },
    {
      field: "jul",
      headerName: "Jul",
      filter: true,
      sortable: true,
    },
    {
      field: "aug",
      headerName: "Aug",
      filter: true,
      sortable: true,
    },
    {
      field: "sep",
      headerName: "Sep",
      filter: true,
      sortable: true,
    },
    {
      field: "oct",
      headerName: "Oct",
      filter: true,
      sortable: true,
    },
    {
      field: "nov",
      headerName: "Nov",
      filter: true,
      sortable: true,
    },
    {
      field: "Dec",
      headerName: "Dec",
      filter: true,
      sortable: true,
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div>
        <h2 className="heading">Revenue Report</h2>
      </div>

      <div style={{ marginBottom: "5px" }}>
        <button
          className="small-btn"
          style={{ visibility: rowData ? "visible" : "hidden" }}
          onClick={() => {
            if (rowData) {
              exportGridDataAsCSV();
            }
          }}
        >
          Export as CSV
        </button>
      </div>

      {!rowData && (
        <div className="dummy-conatiner">
          <CircularProgress size={40} />
        </div>
      )}
      {rowData && (
        <div className="ag-theme-alpine">
          <AgGridReact
            ref={agGridRef}
            paginationPageSize={12}
            pagination={true}
            domLayout="autoHeight"
            rowData={rowData}
            columnDefs={columnDefs}
            enableCellTextSelection={true}
          ></AgGridReact>
        </div>
      )}
    </motion.div>
  );
};

export default RevenueReport;
